import { types } from "../types";

const initialState = {
    data: [],
    organizationSelected: ''
}

const organizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.ORGANIZATIONS_LIST:
            
            return {
                ...state,
                data: action.data,
                organizationSelected: action.organizationSelected
            }
    
        default:
            return state;
    }
}
export default organizationReducer;